import api from "../../../api/axios";

// Shared Task mutation transport for /tasks and /tasks/calendar.
// Uses the existing ModelViewSet — no parallel API.

export const createCalendarTask = (body, { signal } = {}) =>
  api.post("/crm/tasks/", body, { signal }).then((res) => res.data);

export const updateCalendarTask = (taskId, body, { signal } = {}) =>
  api.patch(`/crm/tasks/${taskId}/`, body, { signal }).then((res) => res.data);

export const deleteCalendarTask = (taskId, { signal } = {}) =>
  api.delete(`/crm/tasks/${taskId}/`, { signal }).then((res) => res.data);
